
export const config = {
    apiUrl: 'https://licenseandactivation-app.azurewebsites.net/api/',
    AzureADUrl: 'https://softwaremanagementportal.sensitsystems.net/',
    ReleaseVersionNo: 'Production (ver 3.0.27)',
    TokenGenerationUrl: 'https://licenseandactivation-app.azurewebsites.net/'
}

// For Staging
// export const config = {
//     apiUrl: 'https://licenseandactivationapi-stage.sensitsystems.net/api/',
//     AzureADUrl: 'https://softwaremanagementportal-stage.sensitsystems.net/',
//     ReleaseVersionNo: 'stage (ver 2.0.36)',
//     TokenGenerationUrl: 'https://licenseandactivationapi-stage.sensitsystems.net/'
// }

//For Development
// export const config = {
//     apiUrl: 'https://licenseandactivationapi-developer.sensitsystems.net/api/',
//     AzureADUrl: 'https://softwaremanagementportal-developer.sensitsystems.net/',
//     ReleaseVersionNo: 'Development (ver 1.0.31)',
//     TokenGenerationUrl: 'https://licenseandactivationapi-developer.sensitsystems.net/'
// }

// For Local
// export const config = {
//     apiUrl: 'https://localhost:44381/api/',
//     AzureADUrl: 'http://localhost:3003/',
//     ReleaseVersionNo: 'Development (ver 1.0.27)',
//     TokenGenerationUrl: 'https://localhost:44381/' 
// }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/config.ts